"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionMarkerMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useInnerCoordinates_1 = require("../../map/projection/useInnerCoordinates");
const map_1 = require("../../map");
const getMarkerType = (type) => {
    switch (type) {
        case "polygon":
            return "polygon";
        case "linie":
            return "line";
        case "point":
            return "point";
    }
};
const PositionMarkerMap = ({ position, type, editable, onChangeGeometry, onChangePoint }) => {
    const markerType = getMarkerType(type);
    const location = (0, react_1.useMemo)(() => {
        if (!position.position)
            return null;
        const point = [position.position.x, position.position.y];
        return (0, useInnerCoordinates_1.convertInnerLocationToGPS)(point);
    }, [position.position]);
    // console.log("ABC location", location, position)
    const onChangePointHandler = (location) => {
        const innerLocation = (0, useInnerCoordinates_1.convertGPSToInnerLocation)(location);
        onChangePoint?.(innerLocation);
    };
    if (markerType !== "point")
        return ((0, jsx_runtime_1.jsx)(map_1.PolygonDetailMarkerMap, { geometry: position.geometryPoints ?? null, type: markerType, editable: editable, onNewGeometry: onChangeGeometry, hideIcon: true }));
    return ((0, jsx_runtime_1.jsx)(map_1.PointDetailMarkerMap, { location: location, editable: editable, onNewLocation: onChangePointHandler }));
};
exports.PositionMarkerMap = PositionMarkerMap;
